import { render, staticRenderFns } from "./comp_OrderListCard.vue?vue&type=template&id=06f6fc4d&scoped=true&"
import script from "./comp_OrderListCard.vue?vue&type=script&lang=js&"
export * from "./comp_OrderListCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_OrderListCard.vue?vue&type=style&index=0&id=06f6fc4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6fc4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
